import InternalSymbol from '../utils/symbol';
export * from '../utils/symbol';
export var SYMBOL_UNSET_FIELD_NAME = InternalSymbol.for('UNSET_FIELD_NAME');
export var SYMBOL_UPDATE_COMMAND = InternalSymbol.for('UPDATE_COMMAND');
export var SYMBOL_QUERY_COMMAND = InternalSymbol.for('QUERY_COMMAND');
export var SYMBOL_LOGIC_COMMAND = InternalSymbol.for('LOGIC_COMMAND');
export var SYMBOL_GEO_POINT = InternalSymbol.for('GEO_POINT');
export var SYMBOL_GEO_LINE_STRING = InternalSymbol.for('SYMBOL_GEO_LINE_STRING');
export var SYMBOL_GEO_POLYGON = InternalSymbol.for('SYMBOL_GEO_POLYGON');
export var SYMBOL_GEO_MULTI_POINT = InternalSymbol.for('SYMBOL_GEO_MULTI_POINT');
export var SYMBOL_GEO_MULTI_LINE_STRING = InternalSymbol.for('SYMBOL_GEO_MULTI_LINE_STRING');
export var SYMBOL_GEO_MULTI_POLYGON = InternalSymbol.for('SYMBOL_GEO_MULTI_POLYGON');
export var SYMBOL_SERVER_DATE = InternalSymbol.for('SERVER_DATE');
export var SYMBOL_REGEXP = InternalSymbol.for('REGEXP');
